/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Knp_Lookup_Guides_Restricted_InfoInputs */



/**
* | output |
* | --- |
* | "Some guides may be restricted based on your group membership." |
*
* @param {Knp_Lookup_Guides_Restricted_InfoInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_lookup_guides_restricted_info = /** @type {((inputs?: Knp_Lookup_Guides_Restricted_InfoInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Lookup_Guides_Restricted_InfoInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Certains guides peuvent etre restreints en fonction de votre appartenance a un groupe.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Einige Reiseführer sind möglicherweise nur für Mitglieder bestimmter Gruppen zugänglich.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Alcune guide potrebbero essere soggette a restrizioni in base all'appartenenza al gruppo.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Доступ к некоторым руководствам может быть ограничен в зависимости от вашего членства в группе.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Algunas guías pueden tener restricciones según la membresía de su grupo.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("部分导游服务可能因您所在的团体而受到限制。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("一部のガイドは、グループのメンバーシップに基づいて制限される場合があります。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("आपकी समूह सदस्यता के आधार पर कुछ गाइड प्रतिबंधित हो सकते हैं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Alguns guias podem ter restrições dependendo da sua participação no grupo.")
	return /** @type {LocalizedString} */ ("Some guides may be restricted based on your group membership.")
});